import(/* webpackMode: "eager" */ "/app/src/app/refund-policy/page.tsx");
